<template>
  <slot />
</template>
<script setup>
// The homepage places the header and footer itself, around the curtain (storyblok/SbHomePage.vue)
const { formatDefault } = useHrMeta()
const { load } = useNavigation()
useStageTheme()
formatDefault()
await load()
</script>
